"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M13 4H3c-.5 0-1 .5-1 1v6c0 .5.5 1 1 1h10c.5 0 1-.5 1-1V5c0-.5-.5-1-1-1z"];
//# sourceMappingURL=symbol-rectangle.js.map